<div
    [id]="id()"
    [attr.data-testId]="currentTestId()"
    [attr.data-styleTarget]="id()"
    [attr.data-uiTarget]="'card'"
    class="rounded-md p-4 dat-border-card"
>
    <header class="grid items-center grid-cols-[32px_1fr]">
        <iq-builder-label
            class="iq-md"
            [label]="info.type?.label"
            [tooltipBody]="info.type?.tooltipBody"
        ></iq-builder-label>
        <iq-builder-label
            class="iq-md"
            [label]="info.name?.label"
        ></iq-builder-label>
    </header>
    <main class="pl-8 grid grid-cols-1 gap-y-2">
        @for (key of bodyKeys; track key) {
        <iq-builder-label
            class="iq-md iq-md-label"
            [label]="info?.[key]?.label"
            [tooltipBody]="info?.[key]?.tooltipBody"
            [tooltipHeader]="info?.[key]?.tooltipHeader"
        ></iq-builder-label>
        }
    </main>
</div>
